import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProfileAvatarComponent } from '@rma/public/profiles/public/ui-avatar-legacy';

export interface AgentToggleDetails {
  agentCode: string;
  agentName: string;
  avatarImage?: string;
  checked: boolean;
}

@Component({
  selector: 'rma-agent-toggle-row',
  templateUrl: './agent-toggle-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckboxModule, ProfileAvatarComponent],
  host: {
    class:
      'flex items-center gap-x-6 gap-y-2 overflow-x-auto md:grid md:grid-cols-[repeat(auto-fill,minmax(11rem,1fr))] md:overflow-x-visible',
  },
})
export class AgentToggleRowComponent {
  readonly agents = input.required<readonly AgentToggleDetails[]>();
  readonly toggled = output<string>();
}
